import { render, staticRenderFns } from "./BaseCardShell.vue?vue&type=template&id=2d62a8d2"
import script from "./BaseCardShell.vue?vue&type=script&lang=ts"
export * from "./BaseCardShell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports